import ApiService from '../apiService'
import type {
  ContributionKind,
  ContributionModerationDto,
  ContributionStatus,
} from '../types/contributions'

/**
 * The moderator side of community suggestions.
 *
 * Every path here is behind Moderator-or-Admin on the server, on the controller rather than on each
 * action — so a new endpoint cannot ship without the check.
 */
export const contributionModerationApi = {
  /** The queue, oldest first. */
  getQueue: (params?: {
    status?: ContributionStatus
    kind?: ContributionKind
    skip?: number
    take?: number
  }) =>
    ApiService.get<ContributionModerationDto[]>('/api/moderation/contributions', params),

  getOne: (id: string) =>
    ApiService.get<ContributionModerationDto>(`/api/moderation/contributions/${id}`),

  /** How many are waiting, for the sidebar badge. */
  getPendingCount: () => ApiService.get<number>('/api/moderation/contributions/count'),

  /** Accept it, and apply it. */
  approve: (id: string, note?: string) =>
    ApiService.post<void>(`/api/moderation/contributions/${id}/approve`, { note }),

  /** Refuse it. The reason reaches the contributor, so the server requires one. */
  reject: (id: string, reason: string) =>
    ApiService.post<void>(`/api/moderation/contributions/${id}/reject`, { reason }),
}

export const CONTRIBUTION_QUERY_KEYS = {
  all: ['contributions'] as const,
  queue: (params?: unknown) => ['contributions', 'queue', params] as const,
  pendingCount: ['contributions', 'pending-count'] as const,
}
